import React from "react";

import CodePill from './CodePill'
import {Link} from 'react-router-dom'
import { useTranscriptName } from 'hooks/transcripts/queries';

function TranscriptPillLink(props) {
  const { data: transcript } = useTranscriptName(props.id);
  const transcriptName = transcript?.name || 'Untitled';

  const name = props.count ? `${transcriptName} (${props.count})` : transcriptName
  return (
    <span style={{marginRight:4}}>
      <Link style={{ textDecoration: 'none' }} onClick={props.onClick} to={`/transcripts/${props.id}`}>
        <CodePill
          dark
          name={name}
        />
      </Link>
      {' '}
    </span>

  );
}

export default TranscriptPillLink;
